<template>
<div>
    <div v-if="members.length">
        <transition-group 
			name="feed-transition"
			tag="div"
			class=""
			enter-active-class="animated fadeInUp" 
			leave-active-class="animated fadeOutDown">
            <div class="md:flex mb-12" v-for="(item, index) in members" :key="index">
                <div class="md:w-32">
                    <img v-lazy="item.logo.sizes.medium" :alt="item.logo.alt" v-if="item.logo" class="mb-2 p-4 border bg-white">
                </div>
                <div class="flex-1 md:pl-6 text-base">
                    <h2 class="mb-2" v-html="item.title"></h2>
                    <div>{{item.address}}</div>
                    <div>{{item.address_line_2}}</div>
                    <div class="mb-4">{{item.city}}, {{item.state}} {{item.zip_code}}</div>
                    
                    <div v-if="item.website || item.phone" class="mb-4">
                        <div v-if="item.website"><a :href="checkSiteValue(item.website)">{{item.website}}</a></div>
                        <div v-if="item.phone">p: {{item.phone}}</div>
                    </div>

                    <div v-if="item.member_type_display">
                        <strong>Member Type:</strong> {{item.member_type_display}}
                    </div>
                    <div v-if="item.member_area_of_business_display">
                        <strong>Area of business:</strong> {{item.member_area_of_business_display}}
                    </div>
                    <div v-if="item.business_contact" class="mt-4">
                        <strong>Business Contact</strong>
                        <div class="remove-p-margins mt-4" v-html="item.business_contact"></div>
                    </div>
                </div>
            </div>
		</transition-group>
    </div>
    <div v-else class="mg-banded-accent-2-lightest mg-color-accent-2 py-2 px-4 rounded-lg text-center">
        <div v-if="totalItemsFound == null">
            Loading members...
        </div>
        <div v-else>
            Nothing found.
        </div>
    </div>
    
    <pagination v-if="membersPaginated"></pagination>

    <button v-if="membersPaginated" @click.prevent="paginationToggle" class="my-8">View all</button>

    <button v-if="!membersPaginated" @click.prevent="paginationToggle" class="my-8">Paginate</button>
</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import Pagination from "@/vue-components/pagination";

export default {
    name: "member-list",
    components: {
        pagination: Pagination
    },
    computed: {
        ...mapState(["members", "totalItemsFound", "membersPaginated"])
    },
    methods: {
        ...mapMutations(["updateMembersPaginationFlag"]),
        ...mapActions(["getMembers"]),
        paginationToggle() {
            this.updateMembersPaginationFlag(!this.membersPaginated);
            this.getMembers();
        },
        checkSiteValue(url) {
            if (url.substring(0, 4) !== "http") {
                return "http://" + url;
            }

            return url;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/js/vue-components/member-list.vue